import React from 'react'
import { Accordion } from 'react-bootstrap'
import ListItem from './ListItem'

const List = ({ items, brand}) => {
	return (
		<section className="category">
			{!items && <div className="loading">Bezig met laden..</div>}
			{items && (
				<Accordion>
					{items.map((item) => (
						<ListItem key={item.nodeId} item={item} brand={brand} />
					))}
				</Accordion>
			)}
		</section>
	)
}
export default List
